// API configuration
export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  profitBaseUrl: import.meta.env.VITE_PROFIT_API_BASE_URL || 'http://localhost:3000',
  tradeGroupBaseUrl: import.meta.env.VITE_TRADE_GROUPS_API_BASE_URL || 'http://localhost:3000',
  portfolioBaseUrl: import.meta.env.VITE_PORTFOLIO_API_BASE_URL || 'http://localhost:3000',
  volatilityBaseUrl: import.meta.env.VITE_VOLATILITY_API_BASE_URL || 'http://localhost:3000',
  taxBaseUrl: import.meta.env.VITE_TAX_API_BASE_URL || 'http://localhost:3000',
  taxWriteBaseUrl: import.meta.env.VITE_TAX_WRITE_API_BASE_URL || 'http://localhost:3000',
  taxPipelineBaseUrl: import.meta.env.VITE_TAX_PIPELINE_API_BASE_URL || 'http://localhost:3000',
  endpoints: {
    activeTradeGroups: '/v1/metrics/active-trade-groups',
    // Profit API endpoints
    profitSummary: '/v1/profit/summary',
    profitDaily: '/v1/profit/daily',
    profitDailyRange: '/v1/profit/daily/range',
    profitHourly: '/v1/profit/hourly',
    // Trade Groups API endpoints
    tradeGroupsPreview: '/v1/trade-groups/laddered/preview',
    tradeGroupsCreate: '/v1/trade-groups/laddered',
  },
  timeout: 30000, // 30 seconds - increased from 10s to handle complex profit calculations
};

export default API_CONFIG;
